import React from 'react';
import { useSelector } from 'react-redux';
import TableSingleRow from '../TableSingleRow/TableSingleRow';

const DataTable = () => {
    const allFormData = useSelector(state => state)
    return (
        <div className="table-container">
            <table className="booking-table">
                <thead className="bg-gray-100/50">
                    <tr className="text-black text-left">
                        <th>Destination From</th>
                        <th>Destination To</th>
                        <th className="text-center">Journey Date</th>
                        <th className="text-center">Guests</th>
                        <th className="text-center">Class</th>
                        <th className="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
                    {
                        allFormData.map((single, i) => <TableSingleRow key={i} index={i} {...single}></TableSingleRow>)
                    }
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;